module.exports = __webpack_public_path__ + "img/AT0000002660783.f9024c03.png";